import React from 'react'

import { Modal } from '../../../components/Modal'
import { Title } from '../../../components/Modal/styles'
import { ModalText } from '../../cpf/components/CPFModal/styles'

export const ModalComponent = ({ showModal, setShowModal }) => {
  return (
    <Modal show={showModal} title="O que é o histórico acadêmico?" onDismiss={() => setShowModal(false)}>
      <ModalText>
        O histórico acadêmico é um documento oficial que registra toda a sua trajetória acadêmica referente ao seu rendimento
        escolar.
      </ModalText>
      <ModalText>
        Normalmente, a solicitação desse documento é feita no departamento de coordenação do curso ou pelo portal digital da sua
        universidade.
      </ModalText>
      <Title>O que é o comprovante de matrícula?</Title>
      <br />
      <ModalText>
        O comprovante de matrícula é o documento que indicas as disciplinas nas quais você está matrículado, contendo todo o
        registro das suas atividades acadêmicas.
      </ModalText>
      <ModalText>
        Normalmente, a solicitação desse documento é feita no departamento de coordenação do curso ou pelo portal digital da sua
        universidade.
      </ModalText>
    </Modal>
  )
}
